import countries from "i18n-iso-countries";
import enLocale from 'i18n-iso-countries/langs/en.json'

// useful functions that can be imported when needed
export function ParseMicrosoftJsonDate(dateString) {
    var date = new Date(parseInt(dateString.substr(6)));
    return date;
} 

countries.registerLocale(enLocale);

export const isoCountries = countries;